import { PermissionBase } from './base.permissions';
import { RBAC } from '../rbac';
import { PermissionType } from '../permission-type';

export class PermissionsFactory {

    public static instance: PermissionType[];
    private constructor() { }

    public static getInstance(moduleName: string) {
        // if (this.instance) {
        //     return this.instance;
        // } else {
            let accessibleModules: RBAC = sessionStorage.getItem('userDetails') != 'undefined' ? JSON.parse(sessionStorage.getItem('userDetails')) : null;
            if (accessibleModules) {
                let isModuleExists = accessibleModules.modules.find(d => d.moduleName.toUpperCase() == moduleName.toUpperCase());
                if (isModuleExists) {
                    this.instance = [];
                    if (isModuleExists.readAccess == true) {
                        this.instance.push(PermissionType.READ);
                    }

                    if (isModuleExists.writeAccess == true) {
                        this.instance.push(PermissionType.CREATE);
                    }

                    if (isModuleExists.deleteAccess == true) {
                        this.instance.push(PermissionType.DELETE);
                    }
                    if (isModuleExists.editAccess == true) {
                        this.instance.push(PermissionType.UPDATE);
                    }
                }
            }
            return this.instance;
        // }
    }
}